import React from 'react';
import Layout from '../components/layout';
import Branded from '../components/page-components/branded';

const BrandedPage = () => {
    return (
        <Layout>
            <div className="page-container">
                <Branded />
            </div>
        </Layout>
    );
};

export default BrandedPage;
